import React from "react";
import { Container, Box, Typography } from "@mui/material";
import Projects from "../components/Projects/Projects";

const ProjectsPage = () => {
  return (
    <Box sx={{ pt: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ py: 4 }}>
          <Typography
            variant="h1"
            sx={{
              mb: 1,
              fontSize: { xs: "2.4rem", md: "3.5rem" },
              background: "linear-gradient(135deg, #2563eb, #7c3aed)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Portfolio Projects
          </Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 760 }}>
            Explore my product, academic, profile, and business website
            projects. TapDosh is placed first as the strongest flagship product
            in this portfolio.
          </Typography>
        </Box>

        <Projects />
      </Container>
    </Box>
  );
};

export default ProjectsPage;
